const SYS_ADMIN = "SystemAdmin"
const SALECHANNEL = "SaleChannel"
const FEATURES = {
  Aluguel : 1,
}


export const getMenuData = [
  {
    title: "Dashboard",
    key: "dashboards",
    icon: "fa fa-area-chart",
    count: 4,
    children: [

      {
        title: "Analítico",
        key: "dashboardAnalytics",
        url: "/dashboard/analytics",
        roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Representative", "Salesman", "Operator"],
      },
      {
        title: "Analítico EC",
        key: "dashboardAnalytics-ec",
        url: "/dashboard/analytics/ec",
        roles: ["Merchant-Manager"]
      },
      {
        title: "Faturamento",
        key: "dashboard-merchant",
        url: "/dashboard/faturamento",
        roles: ["SystemAdmin",  "SaleChannel", "Merchant-Manager" ],
      },
      {
        title: "Recebimento",
        key: "dashboardreceivement",
        url: "/dashboard/receivement",
        roles: ["SystemAdmin", "SaleChannel", "Merchant-Manager", "Manager", "Coordinator", "Supervisor", "Representative", "Salesman", "Operator"],
      },
      {
        title: "Performance EC/DIA",
        key: "dashboards/performance/merchant",
        url: "/dashboard/performance/estabelecimento",
        roles: ["SystemAdmin", "SaleChannel",/* "Manager", "Coordinator", "Supervisor", "Representative","Salesman", "Operator" */],
      },
      {
        title: "Performance EC/MES",
        key: "dashboards/performance/merchant-month",
        url: "/dashboard/performance/estabelecimento-mes",
        roles: ["SystemAdmin", "SaleChannel", /* "Manager", "Coordinator", "Supervisor", "Representative","Salesman", "Operator" */],
      },
      {
        title: "Comissionamento",
        key: "commissioner",
        url: "/dashboard/comissionado",
        roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Representative", "Salesman", "Operator"],
      },
      
    ]
  },
  

  {
    category: true,
    title: "Gestão de Acessos",
    key: "acesscontrol",
    roles: ["role1", "role2"]
  },
  {
    title: "Time Operacional",
    key: "operacional",
    icon: "fe fe-users",
    count: 5,
    roles: ["SystemAdmin", "SaleChannel"],
    children: [
      {
        title: "Gerente Comercial",
        key: "gerenteComercial",
        url: "/operacional/gerente-comercial",
        roles: [
          // 'role1',
          // 'role2',
        ]
      },
      {
        title: "Coordenador",
        key: "coordenador",
        url: "/operacional/coordenador",
        roles: [
          // 'role1',
          // 'role2',
        ]
      },
      {
        title: "Supervisor",
        key: "supervisor",
        url: "/operacional/supervisor"
      },
      {
        title: "Representante",
        key: "representante",
        url: "/operacional/representante"
      },
      {
        title: "Vendedor",
        key: "vendedor",
        url: "/operacional/vendedor"
      },

      {
        title: "Financeiro",
        key: "financeiro",
        url: "/operacional/financeiro"
      },
      {
        title: "Operador",
        key: "operador",
        url: "/operacional/operador"
      }

    ]
  },

  {
    title: "Gestão de Usuários",
    key: "users",
    icon: "fe fe-user",
    count: 5,
    roles: ["SystemAdmin", "SaleChannel"],
    url: "/usuarios",
  },

  /*   {
      title: "Comissionamento",
      key: "partnercomission",
      icon: "fe fe-dollar-sign",
      url: "/partnercomission",
      roles: ["SystemAdmin", "SaleChannel"]
    }, */
  {
    category: true,
    title: "Gestão de Clientes",
    key: "client-manager",
    roles: ["SystemAdmin", "SaleChannel"]
  },

  {
    title: "Centro de Custo",
    key: "costcenter",
    icon: "fa fa-briefcase",
    url: "/parceiros/centro-de-custo",
    roles: ["SystemAdmin", "SaleChannel"]
  },
  {
    title: "Estabelecimentos",
    key: "merchant",
    icon: "fa fa-building",
    url: "/merchant",
    roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Representative", "Salesman", "Operator"]
   
  },
  {
    title: "Política Comercial",
    key: "politicacomercial",
    icon: "fa fa-percent",
    roles: ["SystemAdmin", "SaleChannel", "Operator", "Finance"],
    children: [
      {
        title: "Listar",
        key: "politicacomerciallistar",
        url: "/credenciamento/politica-comercial",
        roles: [
          // 'role1',
          // 'role2',
        ]
      },
      {
        title: "Adicionar",
        key: "politicacomercialadicionar",
        url: "/credenciamento/politica-comercial/adicionar",
        roles: [
          // 'role1',
          // 'role2',
        ]
      }
    ]
  },

  // PagSeguro
  {
    title: "PagSeguro",
    key: "pagseguro",
    icon: "fa fa-cubes",
    roles: [SYS_ADMIN, SALECHANNEL],
    children: [
      {
        title: "Cadastros Pendentes",
        key: "pagseguro/pendingInformation",
        url: "/pagseguro/aguardando-informacoes",
        roles: [SYS_ADMIN, SALECHANNEL]
      },
      {
        title: "Ativação Cliente",
        key: "pagseguro/onboarding",
        url: "/pagseguro/onboarding",
        roles: [SYS_ADMIN]
      }
    ]
  },

  // PagSeguro
  {
    title: "Comunicação",
    icon: "fa fa-comments",
    key: "notifications",
    count: 2,
    roles: ["SystemAdmin", "Salechannelx", "Managerx", "Coordinatorx", "Supervisorx", "Operatorx"],
    children: [
      {
        title: "Envio de contrato",
        key: "notifications-contract",
        icon: "fa fa-handshake-o",
        url: "/notification/contract",
        roles: ["SystemAdmin"]
      },
      {
        title: "Campanha App",
        key: "notifications-campaign",
        icon: "fa fa-envelope",
        url: "/notifications/campaign",
        roles: ["SystemAdmin"]
      }

    ]
  },

  {
    category: true,
    title: "Gestão de Equipamentos",
    key: "devicemanager",
    roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Operator"],
  },

  {
    title: "POS / Maquinetas",
    key: "ativosEquipamentos",
    icon: "fe fe-printer",
    roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Operator"],
    children: [
      {
        title: "Listar",
        key: "ativosEquipamentoslistar",
        url: "/ativos/equipamentos",
        roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Operator"],
      },
      {
        title: "Adicionar",
        key: "ativosEquipamentosAdicionar",
        url: "/ativos/equipamentos/add",
        roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Operator"]
      }
    ]
  },

  {
    title: "Gestão de Aluguel",
    key: "deviceRent",
    icon: "fe fe-printer",
    roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Operator"],
    features: [FEATURES.Aluguel],
    children: [
      {
        title: "Contratos",
        key: "deviceRentList",
        url: "/aluguel/contratos",
        roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Operator"],
      },
    ]
  },
  // Financeiro
  {
    category: true,
    title: "Financeiro",
    key: "finance"
  },

  {
    title: "Minhas Taxas",
    key: "fee",
    icon: "fa fa-percent",
    url: "/fee",
    roles: ["SystemAdmin", "Merchant-Manager"]
  },

  {
    title: "Recebimentos",
    key: "recebimentos",
    icon: "fa fa-line-chart",
    url: "/payoutlot",
    roles: ["SystemAdmin", "SaleChannel", "Merchant-Manager", "Manager", "Coordinator", "Supervisor", "Operator"]
  },

  // Financeiro // Faturas
  {
    title: "Faturas",
    key: "invoices",
    icon: "fa fa-list-alt",
    children: [
      {
        title: "Canal de Vendas",
        key: "invoices/saleChannel",
        icon: "fa fa-group",
        url: "/parceiros/canais-de-venda/fatura",
        roles: ["SystemAdmin", "SaleChannel"]
      },
      {
        title: "Estabelecimento",
        key: "invoices/merchant",
        icon: "fa fa-building",
        url: "/invoice",
        roles: ["SystemAdmin", "SaleChannel", "Merchant-Manager", "Manager", "Coordinator", "Supervisor", "Operator"]
      },
    ]
  },
  // Financeiro // Liquidação
  {
    title: "Liquidação",
    key: "finance/liquidation",
    icon: "fa fa-usd",
    roles: ["SystemAdmin", "Salechannelx", "Financex"],
    children: [
      {
        title: "Overview",
        key: "finance/liquidation/overview",
        url: "/liquidacao/overview",
        roles: ["SystemAdmin", "Salechannelx", "Financex"],

      },
      
      {
        title: "Geração de CNAB",
        key: "finance/liquidation/cnab/index",
        url: "/liquidacao/geracao-arquivo-remessa",
        roles: ["SystemAdmin", "Salechannelx", "Financex"],
      },
      {
        title: "Transferência em Lote",
        key: "finance/liquidation/cnab/payout",
        url: "/liquidacao/arquivo-remessa",
        roles: ["SystemAdmin", "Salechannelx", "Financex"],
      },
      
      
    ],
  },
  {
    title: "Conciliação",
    key: "finance/conciliaton",
    icon: "fa fa-usd",
    roles: ["SystemAdmin", "Salechannelx", "Financex"],
    children: [
      {
        title: "Transferências",
        key: "finance/conciliation/payoutConciliation",
        url: "/conciliacao/conciliacao-de-pagamentos",
        roles: ["SystemAdmin", "Salechannelx", "Financex"],
      },
      {
        title: "Fluxo IN/OUT",
        key: "finance/conciliation/in-out",
        url: "/conciliacao/fluxo-entrada-saida",
        roles: ["SystemAdmin", "Salechannelx", "Financex"],
      },
    ]
  },

  // {
  //   title: "Faturas",
  //   key: "faturas",
  //   icon: "fa fa-list-alt",
  //   url: "/invoice",
  //   roles: ["SystemAdmin", "SaleChannel", "Merchant-Manager",  "Manager", "Coordinator", "Supervisor", "Operator"]
  // },

  // {
  //   title: "Faturas Parceiro",
  //   key: "salechannelInvoice",
  //   icon: "fa fa-list",
  //   url: "/parceiros/canais-de-venda/fatura",
  //   roles: ["SystemAdmin", "SaleChannel"]
  // },



  // Relatórios    
  {
    category: true,
    title: "Relatórios",
    key: "reports",
    roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Representative", "Salesman", "Operator"],
  },
  // Relatorios // Estabelecimentos
  {
    title: "Estabelecimentos",
    key: "merchant",
    icon: "fa fa-building",
    roles: ["SystemAdmin", "SaleChannel", "Manager", "Operator"],
    children: [
      {
        title: "Apuração de Faturamento",
        key: "report/merchant/forecast",
        url: "/relatorio/estabelecimento/apuracao-de-faturamento"
      },
      {
        title: "Documentação Pendente",
        key: "report/merchant/pending-files",
        url: "/relatorio/estabelecimento/documentacao-pendente"
      },
    ]
  },



  // Relatorios // Devices
  {
    title: "POS / Maquinetas",
    key: "report/device",
    icon: "fe fe-printer",
    roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Representative", "Salesman", "Operator"],
    children: [
      {
        title: "Última Transação",
        key: "report/device/last-transaction",
        url: "/relatorio/maquineta/ultima-transacao"
      },
    ]
  },

  // Relatorios // Transações
  {
    title: "Transações",
    key: "transactions",
    icon: "fe fe-hard-drive",
    roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Operator"],
    children: [
      {
        title: "Não Sincronizadas",
        key: "transactions-unsync",
        url: "/transactions-unsync",
        roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Operator"]
      },
      {
        title: "Recapturar",
        key: "transactions-recapture",
        url: "/transacoes/recapturar",
        roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Operator"]
      },
    ]
  },


    // Operação 

    {
      category: true,
      title: "Operação",
      key: "operation",
      roles: ["SystemAdmin"],
    },
    {
      title: "Estabelecimento",
      key: "operation-merchant",
      roles: ["SystemAdmin"],
      children:[
        {
          title: "Revisão de contratos",
          key: "merchantcontractreview",
          url: "/merchant/contract-review",
          roles: [
            "SystemAdmin"
            // 'role2',
          ]
        }
  
      ]
    },

  // Auditoria
  {
    category: true,
    title: "Auditoria",
    key: "audit",
    roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Operator"]
  },
  {
    title: "Suspeita de Fraude",
    key: "fraudanalisys",
    icon: "fa fa-user-secret",
    url: "/fraudanalisys",
    roles: ["SystemAdmin", "SaleChannel", "Manager", "Coordinator", "Supervisor", "Operator"]
  },
  {
    title: "Eventos de Auditoria",
    key: "audit-events",
    icon: "fe fe-lock",
    url: "/auditoria/eventos",
    roles: ["SystemAdmin", "SaleChannel"]
  },

  // Configurações
  {
    category: true,
    title: "Configurações",
    key: "configurations",
    roles: ["SystemAdmin", "SaleChannel"]
  },
  {
    title: "Funcionalidades",
    key: "features",
    icon: "fa fa-toggle-on",
    url: "/configuracoes/funcionalidades",
    roles: ["SystemAdmin", "SaleChannel"]
  },
  {
    title: "Templates de E-mail",
    key: "emailtemplates",
    icon: "fa fa-envelope",
    count: 6,
    roles: ["SystemAdmin"],
    children: [
      {
        title: "Listar",
        key: "emailtemplateslist",
        url: "/email-templates",
        roles: ["SystemAdmin"]
      },
      {
        title: "Adicionar",
        key: "emailtemplatesadd",
        url: "/email-templates/add",
        roles: ["SystemAdmin"]
      }
    ]
  },


  {
    category: true,
    title: "Administração Geral",
    key: "admin-general",
    roles: ["SystemAdmin"]
  },

  {
    title: "Parceiros",
    key: "partners",
    icon: "fa fa-group",
    count: 6,
    roles: ["SystemAdmin"],
    children: [
      {
        title: "Adquirentes",
        key: "acquirers",
        url: "/parceiros/adquirentes",
        roles: ["SystemAdmin"]
      },
      {
        title: "Canais de Venda",
        key: "saleChannel",
        url: "/parceiros/canais-de-venda",
        roles: ["SystemAdmin"]
      }
    ]
  },



  {
    title: 'Dashboards',
    key: 'dashboards',
    icon: 'fe fe-home',
    count: 6,
    roles: ["SystemAdmin"],
    children: [
      {
        title: 'Analytics',
        key: 'dashboardAnalytics',
        url: '/dashboard/analytics',
      },
      {
        title: 'Statistics',
        key: 'dashboardStatistics',
        url: '/dashboard/statistics',
      },
      {
        title: 'Ecommerce',
        key: 'dashboardEcommerce',
        url: '/dashboard/ecommerce',
      },
      {
        title: 'Crypto',
        key: 'dashboardCrypto',
        url: '/dashboard/crypto',
      },
      {
        title: 'Crypto Terminal',
        key: 'dashboardCryptoTerminal',
        url: '/dashboard/crypto-terminal',
      },
      {
        title: 'Jira',
        key: 'dashboardJira',
        url: '/dashboard/jira',
      },
      {
        title: 'Helpdesk',
        key: 'dashboardHelpdesk',
        url: '/dashboard/helpdesk',
      },
    ],
  },
  {
    category: true,
    title: 'Apps & Pages',
    roles: ["SystemAdmin"],
  },
  {
    title: 'System Pages',
    key: 'system',
    icon: 'fe fe-user',
    roles: ["SystemAdmin"],
    children: [
      {
        title: 'Login',
        key: 'systemLogin',
        url: '/system/login',
      },
      {
        title: 'Forgot Password',
        key: 'systemForgotPassword',
        url: '/system/forgot-password',
      },
      {
        title: 'Register',
        key: 'systemRegister',
        url: '/system/register',
      },
      {
        title: 'Lockscreen',
        key: 'systemLockscreen',
        url: '/system/lockscreen',
      },
      {
        title: 'Page 404',
        key: 'system404',
        url: '/system/404',
      },
      {
        title: 'Page 500',
        key: 'system500',
        url: '/system/500',
      },
    ],
  },
  {
    title: 'Ecommerce',
    key: 'ecommerce',
    icon: 'fe fe-shopping-cart',
    roles: ["SystemAdmin"],
    children: [
      {
        title: 'Dashboard',
        key: 'ecommerceDashboard',
        url: '/ecommerce/dashboard',
      },
      {
        title: 'Orders',
        key: 'ecommerceOrders',
        url: '/ecommerce/orders',
      },
      {
        title: 'Propduct Catalog',
        key: 'ecommerceProductCatalog',
        url: '/ecommerce/product-catalog',
      },
      {
        title: 'Product Details',
        key: 'ecommerceProductDetails',
        url: '/ecommerce/product-details',
      },
      {
        title: 'Cart',
        key: 'ecommerceCart',
        url: '/ecommerce/cart',
      },
    ],
  },
  {
    title: 'Apps',
    key: 'apps',
    icon: 'fe fe-database',
    roles: ["SystemAdmin"],
    children: [
      {
        title: 'Messaging',
        key: 'appsCart',
        url: '/apps/messaging',
      },
      {
        title: 'Calendar',
        key: 'appsCalendar',
        url: '/apps/calendar',
      },
      {
        title: 'Mail',
        key: 'appsMail',
        url: '/apps/mail',
      },
      {
        title: 'Profile',
        key: 'appsProfile',
        url: '/apps/profile',
      },
      {
        title: 'Gallery',
        key: 'appsGallery',
        url: '/apps/gallery',
      },
    ],
  },
  {
    title: 'Extra Apps',
    key: 'extraApps',
    icon: 'fe fe-hard-drive',
    roles: ["SystemAdmin"],
    children: [
      {
        title: 'Github Explore',
        key: 'extraAppsGithubExplore',
        url: '/extra-apps/github-explore',
      },
      {
        title: 'Github Discuss',
        key: 'extraAppsGithubDiscuss',
        url: '/extra-apps/github-discuss',
      },
      {
        title: 'Digitalocean Droplets',
        key: 'extraAppsDigitaloceanDroplets',
        url: '/extra-apps/digitalocean-droplets',
      },
      {
        title: 'Digitalocean Create',
        key: 'extraAppsDigitaloceanCreate',
        url: '/extra-apps/digitalocean-create',
      },
      {
        title: 'Google Analytics',
        key: 'extraAppsGoogleAnalytis',
        url: '/extra-apps/google-analytics',
      },
      {
        title: 'Wordpress Post',
        key: 'extraAppsWordpressPost',
        url: '/extra-apps/wordpress-post',
      },
      {
        title: 'Wordpress Posts',
        key: 'extraAppsWordpressPosts',
        url: '/extra-apps/wordpress-posts',
      },
      {
        title: 'Wordpress Add',
        key: 'extraAppsWordpressAdd',
        url: '/extra-apps/wordpress-add',
      },
      {
        title: 'Todoist List',
        key: 'extraAppsTodoistList',
        url: '/extra-apps/todoist-list',
      },
      {
        title: 'Jira Dashboard',
        key: 'extraAppsJiraDashboard',
        url: '/extra-apps/jira-dashboard',
      },
      {
        title: 'Jira Agile Board',
        key: 'extraAppsJiraAgileBoard',
        url: '/extra-apps/jira-agile-board',
      },
      {
        title: 'Helpdesk Dashboard',
        key: 'extraAppsHelpdeskDashboard',
        url: '/extra-apps/helpdesk-dashboard',
      },
    ],
  },
  {
    category: true,
    title: 'Components',
    roles: ["SystemAdmin"],
  },
  {
    title: 'Bootstrap',
    key: 'bootstrap',
    icon: 'fe fe-bookmark',
    url: '/ui-kits/bootstrap',
    roles: ["SystemAdmin"],
  },
  {
    title: 'Ant Design',
    key: 'antDesign',
    icon: 'fe fe-bookmark',
    url: '/ui-kits/antd',
    roles: ["SystemAdmin"],
  },
  {
    title: 'Widgets',
    key: 'widgets',
    icon: 'fe fe-image',
    roles: ["SystemAdmin"],
    count: 47,
    children: [
      {
        title: 'General',
        key: 'widgetsGeneral',
        url: '/widgets/general',
      },
      {
        title: 'Lists',
        key: 'widgetsLists',
        url: '/widgets/lists',
      },
      {
        title: 'Tables',
        key: 'widgetsTables',
        url: '/widgets/tables',
      },
      {
        title: 'Charts',
        key: 'widgetsCharts',
        url: '/widgets/charts',
      },
    ],
  },
  {
    title: 'Cards',
    key: 'cards',
    icon: 'fe fe-credit-card',
    roles: ["SystemAdmin"],
    children: [
      {
        title: 'Basic Cards',
        key: 'cardsBasicCards',
        url: '/cards/basic-cards',
      },
      {
        title: 'Tabbed Cards',
        key: 'cardsTabbedCards',
        url: '/cards/tabbed-cards',
      },
    ],
  },
  {
    title: 'Tables',
    key: 'tables',
    icon: 'fe fe-pie-chart',
    roles: ["SystemAdmin"],
    children: [
      {
        title: 'Bootstrap',
        key: 'tablesBootstrap',
        url: '/tables/bootstrap',
      },
      {
        title: 'Ant Design',
        key: 'tablesAntd',
        url: '/tables/antd',
      },
    ],
  },
  {
    title: 'Charts',
    key: 'charts',
    icon: 'fe fe-home',
    roles: ["SystemAdmin"],
    children: [
      {
        title: 'Chartist.js',
        key: 'chartsChartistjs',
        url: '/charts/chartistjs',
      },
      {
        title: 'Chart.js',
        key: 'chartsChartjs',
        url: '/charts/chartjs',
      },
      {
        title: 'C3',
        key: 'chartsC3',
        url: '/charts/c3',
      },
    ],
  },
  {
    title: 'Icons',
    key: 'icons',
    icon: 'fe fe-star',
    roles: ["SystemAdmin"],
    children: [
      {
        title: 'Feather Icons',
        key: 'iconsFeatherIcons',
        url: '/icons/feather-icons',
      },
      {
        title: 'Fontawesome',
        key: 'iconsFontawesome',
        url: '/icons/fontawesome',
      },
      {
        title: 'Linearicons Free',
        key: 'iconsLineariconsFree',
        url: '/icons/linearicons-free',
      },
      {
        title: 'Icomoon Free',
        key: 'iconsIcomoonFree',
        url: '/icons/icomoon-free',
      },
    ],
  },
  {
    category: true,
    title: 'Advanced',
    roles: ["SystemAdmin"],
  },
  {
    title: 'Form Examples',
    key: 'formExamples',
    icon: 'fe fe-menu',
    url: '/advanced/form-examples',
    roles: ["SystemAdmin"],
  },
  {
    title: 'Email Templates',
    key: 'emailTemplates',
    icon: 'fe fe-mail',
    url: '/advanced/email-templates',
    roles: ["SystemAdmin"],
  },
  {
    title: 'Pricing Tables',
    key: 'pricingTables',
    icon: 'fe fe-command',
    url: '/advanced/pricing-tables',
    roles: ["SystemAdmin"],
  },
  {
    title: 'Invoice',
    key: 'invoice',
    icon: 'fe fe-file-text',
    url: '/advanced/invoice',
    roles: ["SystemAdmin"],
  },
  {
    title: 'Utilities',
    key: 'utilities',
    icon: 'fe fe-inbox',
    url: '/advanced/utilities',
    roles: ["SystemAdmin"],
  },
  {
    title: 'Grid',
    key: 'grid',
    icon: 'fe fe-grid',
    url: '/advanced/grid',
    roles: ["SystemAdmin"],
  },
  {
    title: 'Typography',
    key: 'typography',
    icon: 'fe fe-type',
    url: '/advanced/typography',
    roles: ["SystemAdmin"],
  },

];
